import "./segmented-toggle.scss";

/**
 * Two-or-more option segmented control (mutually exclusive choice).
 * Controlled via `value` / `onChange`.
 *
 * @param {object} props
 * @param {{label: string, value: *}[]} props.options - Segment options.
 * @param {*} props.value - Currently selected option value.
 * @param {(value: *) => void} props.onChange - Fired with the picked value.
 * @param {boolean} [props.disabled] - Disable the whole control.
 * @param {string} [props.className] - Extra class on the root.
 * @param {string} [props.ariaLabel] - Accessible group label.
 */
function SegmentedToggleAtom({
	options = [],
	value,
	onChange,
	disabled = false,
	className = "",
	ariaLabel,
}) {
	const rootClass = ["segmented-toggle", className].filter(Boolean).join(" ");
	return (
		<div className={rootClass} role="group" aria-label={ariaLabel}>
			{options.map((option) => {
				const active = option.value === value;
				return (
					<button
						key={String(option.value)}
						type="button"
						className={`segmented-toggle__option${
							active ? " segmented-toggle__option--active" : ""
						}`}
						aria-pressed={active}
						disabled={disabled}
						onClick={() => !active && onChange?.(option.value)}
					>
						{option.label}
					</button>
				);
			})}
		</div>
	);
}

export default SegmentedToggleAtom;
